import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, putInCanvas, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.MUNITIONS_SUPPLY_UNIT)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const canvas = createCanvas(0, 0)
				const ctx = canvas.getContext("2d")

				const imgMsu = await getImage("msu")
				const imgTop = await getImage("msu_top")

				putInCanvas(canvas, ctx, imgMsu)

				ctx.drawImage(imgTop,
					imgMsu.width / 2 - imgTop.width / 2,
					imgMsu.height / 2 - imgTop.height / 2
				)

				return [{ image: await toImage(canvas) }]
			}
		}
	}
)
